export default class ChatEntry {

    static TYPE_GROUP = 'group';
    static TYPE_TEAM = 'team';
    static TYPE_SINGLE = 'single';
    static NAME_MAX_LENGTH = 50;

    constructor () {
        this.id = null;
        this.createdAt = null;
        this.terminatedAt = null;
        this.lastViewAt = null;
        this.isNewSingleChat = null;
        this.name = null;
        this.count = null;
        this.lastMessageCreatedAt = null;
        this.department = null;
        this.children = null;
        this.users = null;
        this.type = null;
        this.userIsAllowedToCreateMessages = null;
        this.userIsAllowedToManageMessages = null;
        this.isEditable = null;
        this.isDeletable = null;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        const chat = new ChatEntry();
        chat.id = data.id;
        chat.createdAt = data.createdAt ? Date.parse(data.createdAt) : null;
        chat.terminatedAt = data.terminatedAt ? Date.parse(data.terminatedAt) : null;
        chat.lastViewAt = data.lastViewAt ? Date.parse(data.lastViewAt) : null;
        chat.isNewSingleChat = data.isNewSingleChat;
        chat.name = data.name;
        chat.count = data.count;
        chat.lastMessageCreatedAt = data.lastMessageCreatedAt ? Date.parse(data.lastMessageCreatedAt) : null;
        chat.department = typeof data.department === 'string' ? data.department : '';
        if (data.children) {
            chat.children = data.children;
        }
        if (data.users) {
            chat.users = data.users;
        }
        chat.type = data.type;
        chat.userIsAllowedToCreateMessages = data.userIsAllowedToCreateMessages;
        chat.userIsAllowedToManageMessages = data.userIsAllowedToManageMessages;
        chat.isEditable = data.isEditable;
        chat.isDeletable = data.isDeletable;

        Object.seal(chat);
        return chat;
    }

    isSingleChat() {
        return this.type === ChatEntry.TYPE_SINGLE;
    }

    isGroupChat() {
        return this.type === ChatEntry.TYPE_GROUP;
    }

    isTerminated() {
        return this.terminatedAt !== null;
    }
}
